import React from 'react'
import classnames from 'classnames'

import styles from './ProgressBar.module.scss'

type ProgressBarProps = {
  progress: number
  circular?: boolean
}

export default React.memo(function ProgressBar({ progress, circular }: ProgressBarProps) {
  const circumference = 2 * Math.PI * 4
  const strokeOffset = 0.25 * circumference
  const strokeDasharray = (progress / 100) * circumference

  return (
    <div
      className={classnames(styles.ProgressBar, { [styles.circular]: circular })}
      style={{ '--progress': `${progress / 100}` } as any}
    >
      {circular && (
        <>
          <svg viewBox="0 0 10 10">
            <circle cx={5} cy={5} r={4} />
            <circle
              cx={5}
              cy={5}
              r={4}
              strokeDasharray={`${strokeDasharray}, ${circumference - strokeDasharray}`}
              strokeDashoffset={strokeOffset}
            />
          </svg>
          <span>{progress}%</span>
        </>
      )}
    </div>
  )
})
